module.exports = __webpack_public_path__ + "static/media/c12e-wifi.d53576a6.png";